export default class CurrencyCode {
  constructor(item){
    this.code = item.code.toLowerCase();
    this.name = item.code;
  }

  static createFromData(data) {
    if (data == null) throw new Error("Cannot create CurrencyCode from data if data is null.");
    return new CurrencyCode(data);
  }
}
